/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSortContactSettingRequestContactSettingsInnerFromJSON, UpdateSortContactSettingRequestContactSettingsInnerToJSON } from './UpdateSortContactSettingRequestContactSettingsInner';
export function UpdateSortContactSettingRequestFromJSON(json) {
    return UpdateSortContactSettingRequestFromJSONTyped(json, false);
}
export function UpdateSortContactSettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactSettings: !exists(json, 'contact_settings')
            ? undefined
            : json['contact_settings'].map(UpdateSortContactSettingRequestContactSettingsInnerFromJSON)
    };
}
export function UpdateSortContactSettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_settings: value.contactSettings === undefined
            ? undefined
            : value.contactSettings.map(UpdateSortContactSettingRequestContactSettingsInnerToJSON)
    };
}
